import TextArea from '@/molecules/TextArea.vue';
import defaultValidators from '@/helpers/default-validators';
import stratPageStress from '@/parcours/flows/stress/stratPageStress.vue';
import lvlStress from '@/parcours/flows/stress/lvlStress.vue';
import { withGlobalFlow } from '@/parcours/flowGlobalSteps';
import { usePreventionParcours } from '@/parcours/composables/usePreventionParcours';
import SymptomsDisplay from '@/parcours/flows/shared/SymptomsDisplay.vue';
import { symptomsStressConfig } from '@/parcours/flows/stress/symptomsStress.config';
import ShowMore from '@/parcours/flows/stress/showMore.vue';
import SpecialistSelector from '@/parcours/components/specialistSelector.vue';

const { update, getById } = usePreventionParcours('/cms/coordinator-patient-stress-infos');

export const stressFlow = withGlobalFlow({
  id: 'stressFlow',

  basePath: '/stressFlow/flow',

  exitRoute: '/stressFlow',

  async onInit({ route }) {
    const id = route.params.reservationId;
    const data = await getById(id);
    return { ...data };
  },

  steps: {
    theme: {
      type: 'component',
      component: stratPageStress,
      title: 'Antécédents',
    },
    lvlStress: {
      type: 'component',
      component: lvlStress,
      title: 'Niveau de stress',
      description:
        'Le score de niveau de stress perçu par le participant correspond au résultat obtenu en réponse au questionnaire PSS 10',
      props: (data: any) => ({ data }),
    },
    symptomDetail: {
      type: 'component',
      header: 'internal',
      isButtonNextDisabled: true,
      component: ShowMore,
      props: (data: any) => ({ data, config: symptomsStressConfig }),
    },
    symptomAnswerQuestion: {
      type: 'component',
      title: 'Questions',
      isButtonNextDisabled: true,
      component: SymptomsDisplay,
      props: (data: any) => ({ data, config: symptomsStressConfig }),
    },
    recommandation: {
      id: 'recommendation_health_professional',
      type: 'component',
      title: 'Recommandations',
      description:
        "Je recommande au patient d'aller consulter le(s) professionnel(s) de santé suivant(s):",
      component: SpecialistSelector,
      buttonNextTitle: 'Valider',
      props: {
        specialists: [
          { name: 'Médecin du travail', value: 'Médecin du travail' },
          { name: 'Médecin traitant', value: 'Médecin traitant' },
          { name: 'Psychologue', value: 'Psychologue' },
          { name: 'Psychiatre', value: 'Psychiatre' },
          { name: 'Sophrologue', value: 'Sophrologue' },
          { name: 'Hypnothérapeute', value: 'Hypnothérapeute' },
          { name: 'Naturopathe', value: 'Naturopathe' },
          { name: 'Diététicien', value: 'Diététicien' },
          { name: 'Aucun', value: 'Aucun' },
        ],
      },
    },
    lastComment: {
      type: 'form',
      title: 'Un dernier commentaire ?',
      description: 'Autre commentaire ou recommandation pour le patient',
      schema: {
        validateOnChange: false,
        validateOnBlur: true,
        fields: [
          {
            id: 'other_recommendation_idel',
            type: 'textarea',
            placeholder: 'Votre commentaire ...',
            as: TextArea,
            rules: defaultValidators.textOpt,
          },
        ],
      },
    },
  },

  transitions: {
    theme: { next: 'lvlStress' },
    lvlStress: { next: 'recommandation' },
    symptomDetail: { next: 'symptomAnswerQuestion', back: 'lvlStress' },
    symptomAnswerQuestion: { back: 'symptomDetail' },
    recommandation: { next: 'lastComment' },
    lastComment: { submit: true },
  },

  async onSubmit(data) {
    await update(data?.id, data);
  },
});
